<template>
  <transition name="fade">
    <div class="full-page-modal fade-in">
      <i class="close-rounded-icon" @click="$emit('cancel')" tabindex="0"></i>
      <div class="backdrop modal-backdrop" @click="$emit('cancel')"></div>
      <div class="full-page-modal-body modal-content">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * This gives a full page modal with a close icon
 */
export default {
  name: 'FullPageModal',
  props: [],
  components: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/animations/fade';

.full-page-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 40px;
  z-index: 1040;
}

.close-rounded-icon {
  position: fixed;
  top: 5px;
  right: 5px;
  cursor: pointer;
  z-index: 1040;
}
.full-page-modal-body {
  border-radius: 12px 12px 0 0;
  overflow: hidden;
  position: relative;
  height: 100%;
  animation: slideUp ease 0.25s;
  z-index: 1040;
}

.backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: $modal-backdrop-bg;
  opacity: 0.8;
  backdrop-filter: blur(5px);
}
@keyframes slideUp {
  from {
    transform: translateY(15%);
    opacity: 0.98;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
